import { buildLoginPath, getLoginUniqueId } from './commandCentreRouting';

export const getSlugAwareLoginUrl = (): string => {
  const loginUniqueId = getLoginUniqueId(window.location.pathname, window.location.search);
  return `${window.location.origin}${buildLoginPath(loginUniqueId, window.location.search)}`;
};

export const buildLoginPathForRedirect = (search?: string): string => {
  const loginUniqueId = getLoginUniqueId(window.location.pathname, search || window.location.search);
  return buildLoginPath(loginUniqueId, search || window.location.search);
};

export const redirectToSlugAwareLogin = () => {
  window.location.href = getSlugAwareLoginUrl();
};

export { buildLoginPath } from './commandCentreRouting';
